import { ScreensList, StackMode } from '@shared-core/navigation/screens-list'

export type RouteKind = 'screen' | 'sheet'

export type NavKey = ScreensList | StackMode

function routeKind(key: string): RouteKind {
  return key.startsWith('FORM_SHEET_') ? 'sheet' : 'screen'
}

// Единый реестр направлений навигации — общий для web и mobile (источник правды).
// `kind` — аналог `type` в роутере мобилы: на уровне ВЫЗОВА везде navigation.navigate(KEY, params).
export const NAV_ROUTES: Record<NavKey, RouteKind> = {
  ...(Object.fromEntries(Object.values(ScreensList).map((key) => [key, routeKind(key)])) as Record<
    ScreensList,
    RouteKind
  >),
  [StackMode.AUTHORIZED]: 'screen',
  [StackMode.LOGOUT]: 'screen',
}

export type ScreenKey = {
  [K in NavKey]: `${Extract<K, string>}` extends `FORM_SHEET_${string}` ? never : K
}[NavKey]

export type SheetKey = {
  [K in NavKey]: `${Extract<K, string>}` extends `FORM_SHEET_${string}` ? K : never
}[NavKey]

export type { NavParams } from '@shared-core/navigation/nav-params'

export function getRouteKind(key: NavKey): RouteKind {
  return NAV_ROUTES[key]
}

export function isSheet(key: NavKey): key is SheetKey {
  return NAV_ROUTES[key] === 'sheet'
}

export function isScreen(key: NavKey): key is ScreenKey {
  return NAV_ROUTES[key] === 'screen'
}
